(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('proseed-collection-filter')) {
  customElements.define('proseed-collection-filter', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('details');
      this.breakpoint = window.matchMedia('(max-width: 767px)');
      this.update = () => { this.panel.open = !this.breakpoint.matches || Number(this.panel.dataset.active) > 0; };
      this.escape = (event) => {
        if (event.key === 'Escape' && this.breakpoint.matches && this.panel.open) {
          this.panel.open = false;
          this.panel.querySelector('summary').focus();
        }
      };
      this.classList.add('pc-filters-enhanced');
      this.syncGroup = group => {
        const toggle = group.querySelector('[data-crop-group-toggle]');
        if (!toggle) return;
        const inputs = [...group.querySelectorAll('[data-crop-value]')].filter(input => !input.disabled || input.checked);
        const selected = inputs.filter(input => input.checked).length;
        toggle.checked = inputs.length > 0 && selected === inputs.length;
        toggle.indeterminate = selected > 0 && selected < inputs.length;
        toggle.disabled = inputs.length === 0;
      };
      this.filterChange = event => {
        const group = event.target.closest('[data-crop-group]');
        if (!group) return;
        if (event.target.matches('[data-crop-group-toggle]')) {
          group.querySelectorAll('[data-crop-value]').forEach(input => {
            if (!input.disabled) input.checked = event.target.checked;
          });
        }
        this.syncGroup(group);
      };
      this.querySelectorAll('[data-crop-group]').forEach(this.syncGroup);
      this.update();
      this.breakpoint.addEventListener('change', this.update);
      this.addEventListener('keydown', this.escape);
      this.addEventListener('change', this.filterChange);
    }
    disconnectedCallback() {
      this.breakpoint.removeEventListener('change', this.update);
      this.removeEventListener('keydown', this.escape);
      this.removeEventListener('change', this.filterChange);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
